'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var sort = exports.sort = 130;

var styles = exports.styles = function styles(_styles, props) {
	var columns = {
		'animation': props.animation,
		'duration': props.duration,
		'iterations': props.iterations
	};

	return _extends({}, _styles, columns);
};

var config = exports.config = function config() {
	return {
		label: 'Animation Settings',
		props: [{
			name: 'animation',
			inputType: 'select',
			label: 'Animation',
			default: 'none',
			values: ['none', 'bounce', 'bounceIn', 'bounceOut', 'bounceInDown', 'bounceOutDown', 'bounceInUp', 'bounceOutUp', 'bounceInLeft', 'bounceOutLeft', 'bounceInRight', 'bounceOutRight', 'flip', 'flipInX', 'flipOutX', 'flipInY', 'flipOutY', 'flash', 'pulse', 'rubberBand', 'lightSpeedInRight', 'lightSpeedOutRight', 'lightSpeedInLeft', 'lightSpeedOutLeft', 'shake', 'swing', 'tada', 'wobble', 'fadeIn', 'fadeOut', 'fadeInDown', 'fadeOutDown', 'fadeOutUpBig', 'fadeInUp', 'fadeInDownBig', 'fadeOutDownBig', 'fadeInUpBig', 'fadeInRightBig', 'fadeOutLeftBig', 'fadeInLeft', 'fadeInLeftBig', 'fadeInRight', 'fadeOutLeft', 'fadeOutRight', 'fadeOutRightBig', 'rollIn', 'rollOut', 'zoomIn', 'zoomOutDown', 'zoomOutUp', 'zoomOutRight', 'zoomOutLeft', 'zoomInDown', 'zoomInLeft', 'zoomInRight', 'zoomInUp', 'zoomOut', 'rotateIn', 'rotateInDownLeft', 'rotateInDownRight', 'rotateInUpLeft', 'rotateInUpRight', 'rotateOutDownLeft', 'rotateOutDownRight', 'rotateOutUpLeft', 'rotateOutUpRight', 'rotateOut']
		}, {
			name: 'duration',
			inputType: 'slider',
			label: 'Duration',
			default: 2000,
			min: 500,
			max: 5000,
			step: 100
		}, {
			name: 'iterations',
			inputType: 'slider',
			label: 'Iterations',
			default: 1,
			min: 1,
			max: 10
		}]
	};
};